import React, {PureComponent} from 'react';
import Hammer from 'react-hammerjs';
import * as ReactGA from '../../GA';
import TrueDigitalRange from './TrueDigitalRange';
import TrueDigitalLens from './TrueDigitalLens';
import TrueDigitalThickness from './TrueDigitalThickness';
import TrueDigitalField from './TrueDigitalField';
import i18n from '../../locales/i18n';

import './TrueDigital.css';

const SLIDES = [
    TrueDigitalRange,
    TrueDigitalThickness,
    TrueDigitalLens,
    TrueDigitalField,
];

export default class TrueDigital extends PureComponent {
    state = {slide: 0};

    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/OakleyAuthenticPrescription/${this.state.slide}`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/OakleyAuthenticPrescription/${this.state.slide}`
        );
    }

    onSwipe = event => {
        const slide =
            event.direction === 2
                ? Math.min(this.state.slide + 1, 3)
                : Math.max(this.state.slide - 1, 0);
        this.setState({slide: slide});
    };

    render() {
        const CurrentSlide = SLIDES[this.state.slide];
        const active = this.state.slide;

        const bullets = SLIDES.map((activeSlide, index) => (
            <div
                key={index}
                className={
                    active === index ? 'bullet bullet--active' : 'bullet'
                }
            />
        ));

        return (
            <article className="TrueDigital">
                <Hammer onSwipe={this.onSwipe}>
                    <div className="TrueDigital-container">
                        <CurrentSlide key={active} />
                        <div className="TrueDigital-swipe-indicator">
                            <div className="bullets">{bullets}</div>
                        </div>
                    </div>
                </Hammer>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/trueDigital/TrueDigital.js